import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_TASK_TREND } from './actionTypes';
import { getTaskTrendSuccess, getTaskTrendError } from './actions';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

function* getTaskTrend({ payload: { user } }) {
  try {
    const response = yield call(tasksAPI.getTaskTrend, user.token);
    yield put(getTaskTrendSuccess(response.trend, response.message));
  } catch (error) {
    yield put(getTaskTrendError(error));
  }
}

export function* watchGetTaskTrend() {
  yield takeEvery(GET_TASK_TREND, getTaskTrend);
}

function* getTaskTrendSaga() {
  yield all([fork(watchGetTaskTrend)]);
}

export default getTaskTrendSaga;
